import {createFileRoute, redirect} from '@tanstack/react-router'

/**
 * Legacy short-prefix URL — kept around so existing shared links / emails
 * keep working. Permanently redirects to /live/tournaments/{slug-or-uid}.
 */
export const Route = createFileRoute('/live/t/$tournament_uid')({
    beforeLoad: ({params}) => {
        throw redirect({to: `/live/tournaments/${params.tournament_uid}`} as any)
    },
})
